import { cn } from "@/lib/utils";

/**
 * Uniform empty state for lists/tables/cards.
 *
 * <EmptyState icon={Package} title="No orders yet" description="Create your first order."
 *   action={<Button>Create order</Button>} />
 *
 * props:
 *  - icon: a lucide icon component
 *  - title: string
 *  - description?: string
 *  - action?: ReactNode (CTA)
 *  - tone?: 'default' | 'positive'  (positive = green icon, for "all clear")
 */
export function EmptyState({ icon: Icon, title, description, action, tone = "default", className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center text-center px-4 py-12", className)}>
      {Icon && (
        <Icon
          className={cn("w-16 h-16 mb-4", tone === "positive" ? "text-green-500" : "text-slate-300")}
          strokeWidth={1.5}
        />
      )}
      {title && <h3 className="text-xl font-semibold text-slate-700">{title}</h3>}
      {description && <p className="mt-1 text-sm text-slate-500 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
